import { useContext, useEffect, useState } from 'react';
import { distinctUntilChanged, map, tap } from 'rxjs';

import { RxFormContext } from '../Context';
import { expand } from '../utils/expand';
import { flatObjectCompare } from '../utils/flatObjectCompare';
import { createDebug } from '../utils/debug';

const debug = createDebug('useFormValues');

export function useFormValues() {
    const { initialValues, getValueStream } = useContext(RxFormContext);
    const [state, setState] = useState(initialValues);
    useEffect(() => {
        debug('++mount');
        const sub = getValueStream()
            .pipe(distinctUntilChanged(flatObjectCompare), map(expand), tap(setState))
            .subscribe();
        return () => {
            debug('--unmount');
            sub.unsubscribe();
        };
    }, [getValueStream]);
    return state;
}
